import { render, staticRenderFns } from "./PerfilEditor.vue?vue&type=template&id=e1e251be&scoped=true"
import script from "./PerfilEditor.vue?vue&type=script&lang=js"
export * from "./PerfilEditor.vue?vue&type=script&lang=js"
import style0 from "./PerfilEditor.vue?vue&type=style&index=0&id=e1e251be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e251be",
  null
  
)

export default component.exports